import React from 'react';
import Link from 'next/link';

import ClusterMenu from 'components/common/ClusterMenu';

import { useSelector } from 'store';
import LocalStitchMap from 'components/common/LocalStitchMap';
import { LatLng } from 'constants/type';

const PlaceListService: React.FC = () => {
  const branches = useSelector(state => state.space.branches);

  const mapCenter: LatLng = {
    lat: 37.555419,
    lng: 126.970801,
  };

  return (
    <>
      <ClusterMenu selected={branches.region} />
      <div className="cnts-wrap">
        <h2 className="stit">Local Stitch Branch</h2>
        <div className="retail-list">
          <div className="list-wrap">
            <ul className="branch-type">
              {branches.results &&
                branches.results.map(branch => {
                  const href = `/branch/place/${branch.id}`;

                  return (
                    <li key={branch.id}>
                      <Link href={href}>
                        <a>
                          <div className="info">
                            <strong>{branch.name}</strong>
                            <address>{branch.address}</address>
                          </div>
                          <span className="thumb">
                            <img src={branch.representation_image} alt="" />
                          </span>
                        </a>
                      </Link>
                    </li>
                  );
                })}
            </ul>
          </div>
          <LocalStitchMap
            center={mapCenter}
            branches={branches.results}
            zoom={12}
          />
        </div>
      </div>
    </>
  );
};

export default PlaceListService;
